#import "../../common/graphql/EntityDocumentsFields.graphql"
mutation AttachDocumentPoolDocuments($input: AttachDocumentPoolInput!) {
  attachDocumentPool(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
      extractionType {
        isExtractProtected
      }
      lookupName {
        lookupName
        id
        isApprovedVendor
        lookupCode
        lookupName
        lookupName2
        address1
        address2
        city
        state
        zipCode
        country
        phone
        emailAccount
      }
    }
  }
}
